module.exports = __webpack_public_path__ + "static/media/Statement of Allegations- LJM Developments (Stoney Creek) Inc. Signed AMENDED..40456dcc.pdf";